module.exports = __webpack_public_path__ + "img/receberbox-light.ec5cf475.png";